import { createAsyncThunk } from '@reduxjs/toolkit'
import { SubDomain } from '../../types/subDomainTypes'
import {
  addSubDomainApi,
  deleteSubDomainApi,
  getAllSubDomains,
  getSubDomainByIdApi,
  getSubDomainbyIdApi,
  getSubDomainbySecurityControlsApi,
  getSubDomainsBySecurityControlIdAndActionIdApi,
  updateSubDomainApi,
} from '../../api/subDomain'
import { handleError } from '../../utils/errorHandler'

export const getSubDomains = createAsyncThunk<
  { subDomains: SubDomain[]; total: number; totalPages: number },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>(
  'subDomain/getAllSubDomains',
  async ({ search, page, pageSize }, thunkAPI) => {
    try {
      const response = await getAllSubDomains({ search, page, pageSize })
      return {
        subDomains: response.subDomains,
        total: response.total,
        totalPages: response.totalPages,
        status: response.status,
        message: response.message,
        erreur: response.erreur,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getSubDomainById = createAsyncThunk<
  SubDomain,
  string,
  { rejectValue: string }
>('subDomain/getSubDomainById', async (id, thunkAPI) => {
  try {
    const response = await getSubDomainByIdApi(id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const deleteSubDomain = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('subDomain/deleteSubDomain', async (AuditId, thunkAPI) => {
  try {
    await deleteSubDomainApi(AuditId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addSubDomain = createAsyncThunk<
  SubDomain,
  SubDomain,
  { rejectValue: string }
>('subDomain/addSubDomain', async (newSubDomain, thunkAPI) => {
  try {
    const response = await addSubDomainApi(newSubDomain)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
export const getSubDomainbyId = createAsyncThunk<
  SubDomain,
  string,
  { rejectValue: string }
>('subDomain/getSubDomainbyId', async (SubDomainId, thunkAPI) => {
  try {
    const response = await getSubDomainbyIdApi(SubDomainId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updateSubDomain = createAsyncThunk<
  SubDomain,
  { updatedSubDomain: SubDomain; _id: string },
  { rejectValue: string }
>('subDomain/updateSubDomain', async ({ updatedSubDomain, _id }, thunkAPI) => {
  try {
    console.log({ updatedSubDomain })
    const response = await updateSubDomainApi(updatedSubDomain, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getSubDomainbySecurityControls = createAsyncThunk<
  SubDomain[],
  string,
  { rejectValue: string }
>(
  'subDomains/getSubDomainsby Securitycontrols',
  async (SecurityControls, thunkAPI) => {
    try {
      const response = await getSubDomainbySecurityControlsApi(SecurityControls)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const getSubDomainsBySecurityControlIdAndActionId = createAsyncThunk<
  SubDomain[],
  { actionId: string; securityControlId: string },
  { rejectValue: string }
>(
  'subDomains/getSubDomainsbyControlIdAndActionId',
  async ({ actionId, securityControlId }, thunkAPI) => {
    try {
      const response = await getSubDomainsBySecurityControlIdAndActionIdApi(
        actionId,
        securityControlId
      )
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
